import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: POST /api/v1/payment/payout-accounts
// body: { provider_type, label?, payment_method, account_details, is_default }
export const savePayoutAccountReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.save_payout_account,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.payoutAccounts}`,
        { provider_type: "nurse", ...payload }
      );
      if (response?.data?.status === true || response?.status === 200 || response?.status === 201) {
        return response.data.data;
      }
      const message = response?.data?.message || i18n.t("toast.failedToSavePayoutAccount");
      toast.error(message);
      return rejectWithValue(message);
    } catch (error) {
      const message = error?.response?.data?.message || i18n.t("toast.failedToSavePayoutAccount");
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);
